import { render } from "./Modal.vue?vue&type=template&id=3e51b8bf&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=3e51b8bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e51b8bf"

export default script